<template>
    <div>
        <table class="form-table">
            <tbody>
                <tr>
                    <td>
                        <label>{{ $t('Dial Times') }}:</label>
                    </td>
                    <td>
                        <CicSelect
                            id="campaign_timestype"
                            :options="[
                                { value: 0, label: $t('Static') },
                                { value: 1, label: $t('Variable') },
                            ]"
                            :value="item.useTimesProfile ? 1 : 0"
                            @input="(val) => updateFieldValue('useTimesProfile', val === 1)"
                        />
                    </td>
                </tr>
                <tr v-if="item.useTimesProfile && multipleViews && item.useMultipleViews">
                    <td colspan="5" style="padding-left: 20px">
                        <table id="dial_times_views" class="campaign-subselection-table">
                            <thead>
                                <tr>
                                    <th style="width: 198px">{{ $t('Table View') }}</th>
                                    <th style="width: 110px">{{ $t('Dial Times type') }}</th>
                                    <th style="width: 150px">{{ $t('Table View column') }}</th>
                                    <th style="width: 150px">{{ $t('Dial Times Profile') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(rule, index) in item.viewRules">
                                    <template v-for="(view, viewIndex) in rule.views">
                                        <tr v-if="view.viewId > 0 && views.some((v) => v.viewId === view.viewId)">
                                            <td style="padding-left: 0; padding-right: 20px; width: 178px">
                                                {{ views.find((v) => v.viewId === view.viewId).name }}
                                            </td>
                                            <td style="padding-left: 0; padding-right: 20px">
                                                <CicSelect
                                                    :options="[
                                                        { value: 0, label: $t('Static') },
                                                        { value: 1, label: $t('Variable') },
                                                    ]"
                                                    :value="view.timesType"
                                                    @input="(val) => updateView(index, viewIndex, 'timesType', val)"
                                                />
                                            </td>
                                            <td style="padding-left: 0; padding-right: 20px">
                                                <div v-if="view.timesType === 0">{{ $t('N/A') }}</div>
                                                <div v-else>
                                                    <CicSelect
                                                        :options="columnOptions(view.viewId)"
                                                        :placeholder="$t('Please select...')"
                                                        :value="view.timesColumn"
                                                        @input="
                                                            (val) => updateView(index, viewIndex, 'timesColumn', val)
                                                        "
                                                    />
                                                </div>
                                            </td>
                                            <td style="padding-left: 0; padding-right: 20px">
                                                <div v-if="view.timesType === 0">{{ $t('N/A') }}</div>
                                                <div v-else>
                                                    <CicSelect
                                                        :options="
                                                            timesProfiles.map((profile) => ({
                                                                value: profile.profileId,
                                                                label: profile.name,
                                                            }))
                                                        "
                                                        :placeholder="$t('Please select...')"
                                                        :value="view.timesProfileId"
                                                        @input="
                                                            (val) => updateView(index, viewIndex, 'timesProfileId', val)
                                                        "
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <template v-if="item.useTimesProfile && !item.useMultipleViews">
                    <tr>
                        <td class="sub-option">{{ $t('Table View column') }}:</td>
                        <td>
                            <CicSelect
                                id="campaign_timescolumn"
                                :options="columnOptions(item.viewId)"
                                :placeholder="$t('Please select...')"
                                :value="item.timesColumn"
                                @input="(val) => updateFieldValue('timesColumn', val)"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="sub-option">{{ $t('Dial Times Profile') }}:</td>
                        <td>
                            <CicSelect
                                id="campaign_timesprofile"
                                :options="
                                    timesProfiles.map((profile) => ({ value: profile.profileId, label: profile.name }))
                                "
                                :placeholder="$t('Please select...')"
                                :value="item.timesProfileId"
                                @input="(val) => updateFieldValue('timesProfileId', val)"
                            />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'EditTimes',
        components: {
            CicSelect,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            multipleViews: {
                type: Boolean,
                default: false,
            },
            timesProfiles: {
                type: Array,
                required: true,
            },
            views: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            columnOptions(viewId) {
                const view = this.views.find((v) => v.viewId === viewId);
                return view && view.columns
                    ? view.columns.map((column) => ({
                          value: column.columnId,
                          label: column.name,
                      }))
                    : [];
            },
            updateFieldValue(name, value) {
                this.$emit('change', name, value);
            },
            updateView(index, viewIndex, name, value) {
                const rules = JSON.parse(JSON.stringify(this.item.viewRules));
                rules[index].views[viewIndex][name] = value;
                this.updateFieldValue('viewRules', rules);
            },
        },
    };
</script>
